export const setFormError = (payload: object) => ({
  type: 'SET_FORM_ERROR',
  payload
})